// extracted by mini-css-extract-plugin
export default {"styledListWrapper":"OBdk0p1dVuCVLB_4RaDo__styledListWrapper___"};